document.addEventListener('DOMContentLoaded', () => {
  const containers = Array.from(document.getElementsByClassName('js-ticket-picker'));

  containers.forEach((container) => {
    const inputWrapper = container.querySelector('.js-ticket-picker-input-wrapper');
    const input = container.querySelector('.js-ticket-picker-input');
    const inputLabel = container.querySelector('.js-ticket-picker-input-label');
    const dropdownItems = container.querySelectorAll('.js-ticket-picker-dropdown-item');

    let documentClickHandler = null;

    const toggle = (event) => {
      event.preventDefault();
      const isActive = container.classList.toggle('is-active');

      if (isActive) {
        documentClickHandler = (e) => {
          if (!container.contains(e.target)) {
            container.classList.remove('is-active');
            document.removeEventListener('click', documentClickHandler);
            documentClickHandler = null;
          }
        };
        document.addEventListener('click', documentClickHandler);
      } else if (documentClickHandler) {
        document.removeEventListener('click', documentClickHandler);
        documentClickHandler = null;
      }
    };

    const handleItemClick = (item) => {
      const value = item.getAttribute('value');
      const label = item.getAttribute('label');

      input.value = value;
      inputLabel.textContent = label;
      container.classList.remove('is-active');
    };

    // Set initial value
    const initialValue = input.value;
    if (initialValue) {
      // Find item with matching value
      const selectedItem = Array.from(dropdownItems).find(
        (item) => item.getAttribute('value') === initialValue,
      );
      if (selectedItem) {
        handleItemClick(selectedItem);
      } else {
        // If no match found, set first item
        const firstItem = dropdownItems[0];
        if (firstItem) {
          handleItemClick(firstItem);
        }
      }
    } else {
      // If no initial value, set first item
      const firstItem = dropdownItems[0];
      if (firstItem) {
        handleItemClick(firstItem);
      }
    }

    inputWrapper.addEventListener('click', toggle);

    dropdownItems.forEach((item) => {
      item.addEventListener('click', () => handleItemClick(item));
    });

    input.addEventListener('focus', toggle);
    input.addEventListener('blur', toggle);
  });
});
